"use client";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";

const API_KEY = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || "";

if (!API_KEY) {
  console.warn("Bugsnag API key is missing for client");
}

if (API_KEY) {
  Bugsnag.start({
    apiKey: API_KEY,
    plugins: [new BugsnagPluginReact()],
    releaseStage: process.env.APP_ENV,
    enabledReleaseStages: ["production", "staging"],
  });
}

const reactPlugin = Bugsnag.getPlugin("react");

export const BugsnagErrorBoundary = reactPlugin
  ? reactPlugin.createErrorBoundary(React)
  : ({ children }: { children: React.ReactNode }) => children;

export default Bugsnag;
